import { buildXml } from "./xml";
import { serializeReport } from "./serializer";

export const generateReport = (state) => serializeReport(state).then(buildXml);

export const reportReference = (username, sessionNumber) =>
  `${username}_${sessionNumber}.xml`;
